import { isIos } from "tools/device";

export const isVolumePluginAvailable = () => {
  return window.plugin?.volume && (!isIos() || window.appversion >= 12009); // ios volume updating after app in bg fixed in 1.20.9
};

export const getVolume = (): Promise<number | null> => {
  return new Promise((resolve) => {
    if (!isVolumePluginAvailable()) {
      resolve(null);
      return;
    }
    window.plugin?.volume?.getVolume((volume) => {
      resolve(volume);
    });
  });
};
